import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Visionaries } from '@/components/visionaries/visionaries'
import { HomeIntro } from '@/components/home/home-intro'
import { HomeSos } from '@/components/home/home-sos'

const Home: FC = (): ReactNode => {
    return (
        <Layout tone='stage'>
            <Seo />

            <div className='hm-stage'>
                <Visionaries />
                <HomeIntro />
                <HomeSos />
            </div>
        </Layout>
    )
}

export default Home
